import { render } from "./GameResult.vue?vue&type=template&id=9d92feb4"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__